import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetSurvey, IGetSurveyQuestion, IGetSurveyQuestions, IGetSurveyResult1, IGetSurveyResult2, IGetSurveyResult3, IGetSurveyResult3Detail, IGetSurveys, IGetSurveyStudentDetail, IGetSurveyStudents, ISurveyParams, ISurveyQuestionParams, ISurveyQuestionReq, ISurveyReq, ISurveyResultParams } from '../models/surveyQuestion.model';
import QueryString from 'qs';

const uri = '/mgmt/survey-question';

export const getSurveyQuestions = (params: ISurveyQuestionParams): AxiosPromise<IGetSurveyQuestions> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const getSurveyQuestion = (questionCode: number): AxiosPromise<IGetSurveyQuestion> => {
  return axios.get(`${uri}/${questionCode}`);
};

export const createSurveyQuestion = (data: ISurveyQuestionReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateSurveyQuestion = (questionCode: number, data: ISurveyQuestionReq): AxiosPromise => {
  return axios.put(`${uri}/${questionCode}`, data);
};

export const getSurveys = (params: ISurveyParams): AxiosPromise<IGetSurveys> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/survey?${qsParams}`);
};

export const getSurvey = (surveyCode: number): AxiosPromise<IGetSurvey> => {
  return axios.get(`${uri}/survey/${surveyCode}`);
};

export const createSurvey = (data: ISurveyReq): AxiosPromise => {
  return axios.post(`${uri}/survey`, data);
};

export const updateSurvey = (surveyCode: number, data: ISurveyReq): AxiosPromise => {
  return axios.put(`${uri}/survey/${surveyCode}`, data);
};

export const finalizeSurvey = (surveyCode: number): AxiosPromise => {
  return axios.post(`${uri}/survey/confirmation/${surveyCode}`);
};

export const getSurveyResult1 = (surveyCode: number, params?: ISurveyResultParams): AxiosPromise<IGetSurveyResult1> => {
  let _uri = `${uri}/survey/${surveyCode}/category`;
  if (params) {
    _uri += `?${QueryString.stringify(params)}`;
  }

  return axios.get(_uri);
};

export const getSurveyResult2 = (surveyCode: number, params?: ISurveyResultParams): AxiosPromise<IGetSurveyResult2> => {
  let _uri = `${uri}/survey/${surveyCode}/choice`;
  if (params) {
    _uri += `?${QueryString.stringify(params)}`;
  }

  return axios.get(_uri);
};

export const getSurveyResult3 = (surveyCode: number): AxiosPromise<IGetSurveyResult3> => {
  return axios.get(`${uri}/survey/${surveyCode}/narrative`);
};

export const getSurveyResult3Detail = (surveyCode: number, questionCode: number, params: ISurveyResultParams): AxiosPromise<IGetSurveyResult3Detail> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/survey/${surveyCode}/narrative/${questionCode}?${qsParams}`);
};

export const getSurveyStudents = (surveyCode: number, params: ISurveyResultParams): AxiosPromise<IGetSurveyStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/survey/${surveyCode}/student?${qsParams}`);
};

export const getSurveyStudentDetail = (surveyCode: number, memberCode: string): AxiosPromise<IGetSurveyStudentDetail> => {
  return axios.get(`${uri}/survey/${surveyCode}/student/${memberCode}`);
};
